import "core-js/modules/es.array.reverse.js";
var _class, _descriptor;
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable, makeObservable } from "mobx";
/**
 * Tracks pending notifications, and provides and interface for adding and removing them.
 * Notification queue is first-in, first-out.
 * Notifications with the same key will only be added once.
 */
let NotificationState = (_class = class NotificationState {
  constructor() {
    _initializerDefineProperty(this, "notifications", _descriptor, this);
    _defineProperty(this, "alreadyNotifiedKeys", new Set());
    makeObservable(this);
  }
  addNotificationToQueue(notification) {
    const alreadyQueued = this.notifications.filter(item => item.title === notification.title && item.message === notification.message).length !== 0;
    const keyNotSeenBefore = notification.key === undefined || !this.alreadyNotifiedKeys.has(notification.key);
    if (!alreadyQueued && keyNotSeenBefore) {
      var _notification$ignore;
      const ignore = typeof notification.ignore === "function" ? notification.ignore() : (_notification$ignore = notification.ignore) !== null && _notification$ignore !== void 0 ? _notification$ignore : false;
      if (!ignore) this.notifications.push(notification);
    }
    if (notification.key !== undefined) {
      this.alreadyNotifiedKeys.add(notification.key);
    }
  }
  dismissCurrentNotification() {
    const removed = this.notifications.shift();
    if (removed !== null && removed !== void 0 && removed.onDismiss) {
      removed.onDismiss();
    }
    // Remove all ignored notifications
    // This is needed here as the action of dismissing the current notification may change "ignore" status of notifications in stack
    this.notifications = this.notifications.filter(n => {
      var _n$ignore;
      return !(typeof n.ignore === "function" ? n.ignore() : (_n$ignore = n.ignore) !== null && _n$ignore !== void 0 ? _n$ignore : false);
    });
    return removed;
  }
  get currentNotification() {
    return this.notifications.length > 0 ? this.notifications[0] : undefined;
  }

  /*
   * @private - used in specs
   */
  getAllNotifications() {
    return this.notifications;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notifications", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "addNotificationToQueue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addNotificationToQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissCurrentNotification", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissCurrentNotification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentNotification", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentNotification"), _class.prototype), _class);
export { NotificationState as default };